(function(){
  "use strict";

  /* תפריט צד */
  var mnav=document.getElementById('mnav'), burger=document.getElementById('burger');
  function menu(open){
    mnav.classList.toggle('is-on',open);
    mnav.setAttribute('aria-hidden',open?'false':'true');
    burger.setAttribute('aria-expanded',open?'true':'false');
    document.body.style.overflow=open?'hidden':'';
  }
  if(burger&&mnav){
    burger.addEventListener('click',function(){menu(!mnav.classList.contains('is-on'));});
    mnav.addEventListener('click',function(e){
      if(e.target.closest('[data-close]')||e.target.closest('a')) menu(false);
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')menu(false);});
  }

  /* פס הודעות מתחלף */
  var ANNO=[
    '&#128293; הנחה למגיעים מהמודעה: 20%',
    '&#127873; + מפצל מצית במתנה'
  ];
  var annoEl=document.getElementById('annoTxt');
  if(annoEl&&ANNO.length>1){
    var ai=0;
    setInterval(function(){
      annoEl.classList.add('is-out');
      setTimeout(function(){
        ai=(ai+1)%ANNO.length;
        annoEl.innerHTML=ANNO[ai];
        annoEl.classList.remove('is-out');
      },350);
    },4200);
  }

  /* שאלות ותשובות */
  document.querySelectorAll('.q__b').forEach(function(b){
    b.setAttribute('aria-expanded','false');
    b.addEventListener('click',function(){
      var q=b.parentElement, open=q.classList.toggle('is-open');
      b.setAttribute('aria-expanded',open?'true':'false');
    });
  });
})();
